<template>
    <v-dialog v-model="getModalCadastroFabricante" max-width="720px">
        <v-card outlined :loading="$store.getters.getOverlay">
            <Alert />
            <v-card-title>
                Cadastro de Fabricante
            </v-card-title>
            <v-form @submit.prevent="salvar" class="px-3">
                <v-card-text>
                    <v-layout row wrap class="">
                        <v-flex xs12 md12>
                            <v-text-field dense outlined v-model="getFabricante.nome" label="Nome"
                                class="ml-3 mr-3">
                            </v-text-field>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-btn class="white--text" color="blue-grey" @click="setModalCadastroFabricante(false)" outlined>Voltar</v-btn>
                    <v-btn v-if="getFabricante.id && $helper.verificaPermissao('cadastrar-fabricante')" color="primary" @click="cadastrarFabricante" outlined>Novo</v-btn>
                    <v-btn v-if="getFabricante.id && $helper.verificaPermissao('excluir-fabricante')" color="error" @click.stop="setModalExcluirFabricante(true)" outlined>Excluir</v-btn>
                    <v-spacer></v-spacer>

                    <v-btn color="success" @click="salvar" outlined :loading="$store.getters.getOverlay" v-if="$helper.verificaPermissao('cadastrar-fabricante') || $helper.verificaPermissao('atualizar-fabricante')">Salvar</v-btn>
                </v-card-actions>
            </v-form>

        </v-card>

        <ModalExcluirFabricante />
    </v-dialog>
</template>

<script>
    import ModalExcluirFabricante from "@/pages/fabricante/ModalExcluir"
    import { mapGetters, mapActions } from 'vuex'
    export default {
        components: {
            ModalExcluirFabricante
        },
        computed: {
            ...mapGetters([
                'getFabricante',
                'getModalCadastroFabricante',
            ])
        },
        methods: {
            ...mapActions([
                'setModalCadastroFabricante',
                'setModalExcluirFabricante',
                'cadastrarFabricante',
                'salvarFabricante',
                'atualizarFabricante',
            ]),
            salvar() {
                if (this.getFabricante.id) {
                    this.atualizarFabricante(this.getFabricante)
                } else {
                    this.salvarFabricante(this.getFabricante)
                }
            },
        },
        created() {
            
        }
    }
</script>